<!-- TEMPLATE -->
<template>
  <v-list-item class="single-node">
    <v-list-item-avatar>
      <v-img :src="logo"></v-img>
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title>{{ title }}</v-list-item-title>
      <v-list-item-subtitle>{{ subtitle }}</v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>



<script>
import Vue from "vue";

export default {
  name: "node-plugin",
  data: function () {
    return {
      dataNode: {},
      nodeId: -1,
      input: {
        number: 0,
      },
    };
  },
  methods: {},
  mounted: function () {
    let self = this;
    Vue.nextTick().then(function () {
      self.nodeId = self.$el.parentElement.parentElement.id.slice(5);
      self.dataNode = self.$we.getNodeFromId(self.nodeId);
    });
  },
  components: {},
  props: {
    logo: String,
    title: String,
    subtitle: String,
    function: String,
  },
};
</script>

<!-- Style -->
<style >
.single-node {
  background: #fff;
  border-radius: 20px;
  border: 1px #000 solid;
}
</style>